// Warning : File loaded by Node. ECMAScript imports/exports don't work.
const Bowser = require('bowser')

/** @type {(userAgent: string) => boolean} */
const mobileDetect = (userAgent) => Bowser.parse(userAgent).platform.type === 'mobile'

module.exports = { mobileDetect }
